<template>
  <div>
    <!-- breadcrumb area start -->
    <div class="breadcrumb-area">
      <div class="row">
        <div class="col-md-12">
          <ol class="breadcrumb font-class">
            <li><a href="/#/home" v-on:click="sendMsg"><span class="fa fa-home"></span></a></li>
            <li><a href="/#/about" v-on:click="sendMsg">关于</a></li>
            <li class="active">资质及相关证书</li>
          </ol>
        </div>
      </div>
    </div>
    <!-- breadcrumb area end -->

    <!-- contact information start -->
    <div class="contant-information pt-20">
      <div class="row">
        <div class="center_column col-xs-12 col-sm-12">
          <div class="rte">
            <h1 style="font-size: 20px">认证证书</h1>
            <hr>
            <div class="row">
              <div class="col-xs-12 col-sm-12">
                <div style="width:50%;margin: 0 auto 50px">
                  <img src="../../assets/about/certificate/attestation/a7.jpg" alt="" style="width:100%;height:auto;">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-3 col-sm-3">
                <div style="width:100%;margin: 0 auto 50px">
                  <img src="../../assets/about/certificate/attestation/a8.png" alt="" style="width:100%;height:auto;">
                </div>
              </div>
              <div class="col-xs-3 col-sm-3">
                <div style="width:100%;margin: 0 auto 50px">
                  <img src="../../assets/about/certificate/patent/p9.png" alt="" style="width:100%;height:auto;">
                </div>
              </div>
            </div>
          </div>
          <div class="rte">
            <h1 style="font-size: 20px">第三方检测报告</h1>
            <hr>
            <div class="row">
              <div class="col-xs-3 col-sm-3">
                <div style="width:100%;margin: 0 auto 50px">
                  <img src="../../assets/about/certificate/attestation/a1.png" alt="" style="width:100%;height:auto;">
                </div>
              </div>
              <div class="col-xs-3 col-sm-3">
                <div style="width:100%;margin: 0 auto 50px">
                  <img src="../../assets/about/certificate/attestation/a2.png" alt="" style="width:100%;height:auto;">
                </div>
              </div>
              <div class="col-xs-3 col-sm-3">
                <div style="width:100%;margin: 0 auto 50px">
                  <img src="../../assets/about/certificate/attestation/a3.png" alt="" style="width:100%;height:auto;">
                </div>
              </div>
              <div class="col-xs-3 col-sm-3">
                <div style="width:100%;margin: 0 auto 50px">
                  <img src="../../assets/about/certificate/attestation/a4.png" alt="" style="width:100%;height:auto;">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-3 col-sm-3">
                <div style="width:100%;margin: 0 auto 50px">
                  <img src="../../assets/about/certificate/attestation/a5.png" alt="" style="width:100%;height:auto;">
                </div>
              </div>
              <div class="col-xs-3 col-sm-3">
                <div style="width:100%;margin: 0 auto 50px">
                  <img src="../../assets/about/certificate/attestation/a6.png" alt="" style="width:100%;height:auto;">
                </div>
              </div>
              <div class="col-xs-3 col-sm-3">
                <div style="width:100%;margin: 0 auto 50px">
                  <img src="../../assets/about/certificate/attestation/a9.png" alt="" style="width:100%;height:auto;">
                </div>
              </div>
              <div class="col-xs-3 col-sm-3">
                <div style="width:100%;margin: 0 auto 50px">
                  <img src="../../assets/about/certificate/attestation/a10.png" alt="" style="width:100%;height:auto;">
                </div>
              </div>
            </div>
          </div>
          <div class="rte">
            <h1 style="font-size: 20px">专利和软著</h1>
            <hr>
            <div class="row">
              <div class="col-xs-3 col-sm-3">
                <div style="width:100%;margin: 0 auto 50px">
                  <img src="../../assets/about/certificate/patent/p1.png" alt="" style="width:100%;height:auto;">
                </div>
              </div>
              <div class="col-xs-3 col-sm-3">
                <div style="width:100%;margin: 0 auto 50px">
                  <img src="../../assets/about/certificate/patent/p2.png" alt="" style="width:100%;height:auto;">
                </div>
              </div>
              <div class="col-xs-3 col-sm-3">
                <div style="width:100%;margin: 0 auto 50px">
                  <img src="../../assets/about/certificate/patent/p3.jpg" alt="" style="width:100%;height:auto;">
                </div>
              </div>
              <div class="col-xs-3 col-sm-3">
                <div style="width:100%;margin: 0 auto 50px">
                  <img src="../../assets/about/certificate/patent/p4.jpg" alt="" style="width:100%;height:auto;">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-3 col-sm-3">
                <div style="width:100%;margin: 0 auto 50px">
                  <img src="../../assets/about/certificate/patent/p5.png" alt="" style="width:100%;height:auto;">
                </div>
              </div>
              <div class="col-xs-3 col-sm-3">
                <div style="width:100%;margin: 0 auto 50px">
                  <img src="../../assets/about/certificate/patent/p6.jpg" alt="" style="width:100%;height:auto;">
                </div>
              </div>
              <div class="col-xs-3 col-sm-3">
                <div style="width:100%;margin: 0 auto 50px">
                  <img src="../../assets/about/certificate/patent/p7.png" alt="" style="width:100%;height:auto;">
                </div>
              </div>
              <div class="col-xs-3 col-sm-3">
                <div style="width:100%;margin: 0 auto 50px">
                  <img src="../../assets/about/certificate/patent/p8.png" alt="" style="width:100%;height:auto;">
                </div>
              </div>
            </div>
          </div>
<!--          <div class="rte">-->
<!--            <h1 style="font-size: 20px">认证证书</h1>-->
<!--            <hr>-->
<!--            <div class="row">-->
<!--              <div class="col-xs-12 col-sm-12">-->
<!--                <div style="width:60%;margin: 0 auto 50px">-->
<!--                  <img src="../../assets/about/certificate/attestation/a7.jpg" alt="" style="width:100%;height:auto;">-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="row">-->
<!--              <div class="col-xs-3 col-sm-3">-->
<!--                &lt;!&ndash;                <div style="width:60%;margin: 0 auto 50px">&ndash;&gt;-->
<!--                &lt;!&ndash;                  <img src="../../assets/about/certificate/attestation/a8.png" alt="" style="width:100%;height:auto;">&ndash;&gt;-->
<!--                &lt;!&ndash;                </div>&ndash;&gt;-->
<!--                <img src="../../assets/about/certificate/attestation/a8.png" alt="">-->
<!--              </div>-->
<!--              <div class="col-xs-3 col-sm-3">-->
<!--                &lt;!&ndash;                <div style="width:60%;margin: 0 auto 50px">&ndash;&gt;-->
<!--                &lt;!&ndash;                  <img src="../../assets/about/certificate/attestation/a9.jpg" alt="" style="width:100%;height:auto;">&ndash;&gt;-->
<!--                &lt;!&ndash;                </div>&ndash;&gt;-->
<!--                <img src="../../assets/about/certificate/attestation/a9.jpg" alt="">-->
<!--              </div>-->
<!--              <div class="col-xs-3 col-sm-3">-->
<!--                &lt;!&ndash;                <div style="width:60%;margin: 0 auto 50px">&ndash;&gt;-->
<!--                &lt;!&ndash;                  <img src="../../assets/about/certificate/attestation/a8.png" alt="" style="width:100%;height:auto;">&ndash;&gt;-->
<!--                &lt;!&ndash;                </div>&ndash;&gt;-->
<!--                <img src="../../assets/about/certificate/attestation/a8.png" alt="">-->
<!--              </div>-->
<!--              <div class="col-xs-3 col-sm-3">-->
<!--                &lt;!&ndash;                <div style="width:60%;margin: 0 auto 50px">&ndash;&gt;-->
<!--                &lt;!&ndash;                  <img src="../../assets/about/certificate/attestation/a9.jpg" alt="" style="width:100%;height:auto;">&ndash;&gt;-->
<!--                &lt;!&ndash;                </div>&ndash;&gt;-->
<!--                <img src="../../assets/about/certificate/attestation/a9.jpg" alt="">-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="row">-->
<!--              <div class="col-xs-4 col-sm-4">-->
<!--                <img src="../../assets/about/certificate/attestation/a1.png" alt="">-->
<!--              </div>-->
<!--              <div class="col-xs-4 col-sm-4">-->
<!--                <img src="../../assets/about/certificate/attestation/a2.png" alt="">-->
<!--              </div>-->
<!--              <div class="col-xs-4 col-sm-4">-->
<!--                <img src="../../assets/about/certificate/attestation/a3.png" alt="">-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="row">-->
<!--              <div class="col-xs-4 col-sm-4">-->
<!--                <img src="../../assets/about/certificate/attestation/a4.png" alt="">-->
<!--              </div>-->
<!--              <div class="col-xs-4 col-sm-4">-->
<!--                <img src="../../assets/about/certificate/attestation/a5.png" alt="">-->
<!--              </div>-->
<!--              <div class="col-xs-4 col-sm-4">-->
<!--                <img src="../../assets/about/certificate/attestation/a6.png" alt="">-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="rte">-->
<!--            <h1 style="font-size: 20px">专利证书</h1>-->
<!--            <hr>-->
<!--            <div class="row">-->
<!--              <div class="col-xs-4 col-sm-4">-->
<!--                <img src="../../assets/about/certificate/patent/p4.jpg" alt="">-->
<!--              </div>-->
<!--              <div class="col-xs-4 col-sm-4">-->
<!--                <img src="../../assets/about/certificate/patent/p2.png" alt="">-->
<!--              </div>-->
<!--              <div class="col-xs-4 col-sm-4">-->
<!--                <img src="../../assets/about/certificate/patent/p3.jpg" alt="">-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="row">-->
<!--              <div class="col-xs-4 col-sm-4">-->
<!--                <img src="../../assets/about/certificate/patent/p5.png" alt="">-->
<!--              </div>-->
<!--              <div class="col-xs-4 col-sm-4">-->
<!--                <img src="../../assets/about/certificate/patent/p6.jpg" alt="">-->
<!--              </div>-->
<!--              <div class="col-xs-4 col-sm-4">-->
<!--                <img src="../../assets/about/certificate/patent/p7.png" alt="">-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="row">-->
<!--              <div class="col-xs-4 col-sm-4">-->
<!--                <img src="../../assets/about/certificate/patent/p8.png" alt="">-->
<!--              </div>-->
<!--              <div class="col-xs-4 col-sm-4">-->
<!--                <img src="../../assets/about/certificate/patent/p1.png" alt="">-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
        </div>
      </div>
    </div>
    <!-- contact information end -->
  </div>
</template>

<script>
import {getContactDetail} from '../../utils/api'

export default {
  name: 'contact',
  data () {
    return {
      contactData: {},
      formLeft: {
        input1: '',
        input2: '',
        input3: ''
      }
    }
  },
  mounted () {
    this.getContactDetail()
  },
  methods: {
    render (String) {
      let temp = ''
      for (let item of String.split('\n')) {
        temp += item + '<br>'
      }
      return temp
    },
    async getContactDetail () {
      let contactData01 = await getContactDetail()
      if (localStorage.getItem('Language') === 'zh') {
        this.contactData = {
          address: this.render(contactData01.address_zh),
          email: contactData01.email,
          phone: contactData01.phone,
          work_time: this.render(contactData01.work_time_zh)
        }
      } else {
        this.contactData = {
          address: this.render(contactData01.address_en),
          email: contactData01.email,
          phone: contactData01.phone,
          work_time: this.render(contactData01.work_time_en)
        }
      }
      // console.log(this.contactData)
    },
    sendMsg () {
      this.$emit('headCurrent', 0)
      window.sessionStorage.setItem('currentFirstIndex', 0)
    }
  }
}
</script>

<!-- 面包屑导航样式 -->
<style scoped>
  .breadcrumb>li+li:before {
    padding: 0 5px;
    color: #000;
    content: ">";
    font-weight: lighter;
  }

  .breadcrumb>li span{
    font-size: 16px;
  }
</style>

<!-- 内容样式 -->
<style scoped>
  .center_column{
    min-height: 400px;
  }

  .center_column p{
    font-size: 17px;
    line-height: 22px;
    margin: 0 0 9px;
    padding: 0;
    border: 0;
    vertical-align: baseline;
    color: #000;
  }

  .rte {
    background: transparent none repeat scroll 0 0;
  }

  .rte div{
    text-align: center;
    margin-bottom: 20px;
  }

  .rte p{
    text-indent: 34px;
    margin-bottom: 20px;
  }

  h1, h2, h3, h4, h5, h6 {
    /*font-family: "Roboto Condensed",sans-serif;*/
    font-weight: 700;
    color: #000;
    text-align: center;
  }

  .block{
    min-height: 250px;
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/about/about-certificate.vue